import Box from '@mui/material/Box';
import { node, string } from 'prop-types';
import React from 'react';

const Container = ({ children, className = '' }) => (
  <Box className={className} sx={{ height: '100%', width: '100%' }}>
    {children}
  </Box>
);

Container.propTypes = {
  children: node.isRequired,
  className: string,
};

export default Container;
